// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_identity_pool_id:
    "us-east-1:9f8836bf-cc7e-48f1-836c-9daa9278ee45",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_oJEEfkUkx",
  aws_user_pools_web_client_id: "3krgaj30t0eecbuviiarr6sq5b",
  oauth: {},
  stripe_key:
    "pk_live_51KWLzaKSMMiABBtCOKKlj5C2i5BdViKoTiNSoi2GBl2GxvjspIMqwOL80Zhh0kgcA4C21yKSF7xgW7d04IXwKVg100u4I7838u",
  aws_appsync_graphqlEndpoint:
    "https://merchant-api.1800spirits.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  stripe_redirect_uri: 'https://merchant.1800spirits.com/stores',
  stripeClientId: 'ca_LO1kWKHcombC30VaRxOnQ3mgXVlB6hok',
  aws_appsync_apiKey: "da2-kil6xajfajeztdmbpwdjampckq",

  aws_geo_mapName: "spirits-prd-platform-Here-map",
  aws_geo_mapIndexName: "spirits-prd-platform-Here-singleusePlaceindex",
  aws_s3_imagesUrl:
    "http://1800spirits-images.s3-website-us-east-1.amazonaws.com",
  firebase_vapidKey:
    "BO7qQGfsWgtkIWL63bK23X5Q-SVNPYwS0SWs1ycEhnwsTZyNhxHgm1NY9YeZVeXUBT4rB_EJzJKdIuxb_GcWdUs",
};

export default awsmobile;